import React from 'react';

import { Button } from 'reactstrap';

//Componentes auxiliares:
import PasswordChangeForm from './PasswordChangeForm';
import CustomModal from '../../../tools/components/CustomModal';

let PasswordChangeModal = (props) => {
    return (
        <CustomModal isTheModalOpen={props.isOpen} modalToggle={props.modalToggle}
            size="md" title={getModalTitle()} footerButtons={[
                <Button color="info" key="changePasswordSubmitButton" onClick={() => {
                    try {
                        document.getElementById("changePasswordSubmitButton").click();
                    }
                    catch (error) { console.log(error); }
                }}>Confirmar cambio</Button>
            ]} >

            <PasswordChangeForm modalToggle={props.modalToggle} />

        </CustomModal>
    );
}

let getModalTitle = () => {
    return (
        <p style={{ marginBottom: 5, textTransform: "capitalize" }}>
            Cambiar
            <span style={{ textTransform: "none", marginLeft: 5 }}>
                <b>contraseña</b>
            </span>
        </p>
    );
}

export default PasswordChangeModal;